<template>
  <div>
    <!--    <div style="color: red">DEBUG store.getters.homepageSliderImages.length={{$store.getters.homepageSliderImages.length}}</div>-->
    <carousel
      v-if="$store.getters.homepageSliderImages.length>0"
      class="homepageSlider cssClass"
      :class="{isMobile: isMobile, isMd: !isMobile && !$store.getters.isKiosk, isKiosk: $store.getters.isKiosk}"
      :per-page="1"
      loop
      :navigationEnabled="true"
      navigationNextLabel=""
      navigationPrevLabel=""
      :paginationEnabled="false"
      :autoplay="true"
      :autoplayTimeout="6000"
      :autoplayHoverPause="false"
    >
      <slide
        v-for="(image, index) in sliderImages"
        @click.native.passive="showImage(image.deepLink||'')"
        :key="index"
      >

        <v-img v-if="$store.getters.isKiosk && !densed"
               aspect-ratio="0.6" :src="image.URL"
               :class="{pointer: !!image.deepLink}"
               cover max-height="1100"></v-img>

        <v-img v-else-if="$store.getters.isKiosk && densed"
               aspect-ratio="1.777" :src="image.URL"
               :class="{pointer: !!image.deepLink}"
               cover max-height="350"></v-img>

        <v-img v-else
               aspect-ratio="1.777" :src="image.URL"
               :class="{pointer: !!image.deepLink}"
               cover max-height="800"></v-img>

      </slide>
    </carousel>
  </div>
</template>

<script>
import * as qconst from '../vendor/qconstants'
import store from '../store/store'
import * as xhr from '../api/xhr.js'
import * as util from "@/vendor/util";
import {Carousel, Slide} from 'vue-carousel';
import {getGlobalValue, getGlobalValueOrZero, setGlobalKeyValue} from "@/util/globalState";

export default {
  props: {
    tablet: Boolean,
    densed: {
      type: Boolean,
      default: false
    }
  },
  components: {
    Carousel,
    Slide
  },
  data() {
    return {
      touchEvent: null,
      // sliderImages: []
    };
  },
  computed: {
    isMobile() {
      return store.getters.deviceClass !== 'md';
    },
    sliderImages() {
      return store.getters.homepageSliderImages;
    },
    // sliderBorder() {
    //   return {
    //     borderRadius: this.tablet ? '0px' : '25px',
    //   }
    // }
  },
  mounted() {
    this.loadSliderImageURLs();
  },

  methods: {
    async loadSliderImageURLs() {
      let now = Date.now();
      let easer = getGlobalValueOrZero('loadEaserSliderImages');
      if (!easer || now - parseInt(easer) > 1 * 60 * 1000) {
        setGlobalKeyValue('loadEaserSliderImages', now);
      } else {
        //eased
        return;
      }
      let msg = {
        action: qconst.action$qsignal_LoadDocs,
        collectionName: 'homepageSliderImages'
      };
      await xhr.xhrSend(true, msg, (data) => {
        if (data && data.ok) {
          let docs = data.docs;
          if (docs.length > 0) {
            console.log('homepageSliderImages loaded: ' + docs.length);
            store.commit('homepageSliderImages', docs);
          } else {
            console.log('homepageSliderImages loaded 0');
          }
        } else {
          console.log('homepageSliderImages loaded notOk');
        }
      }, (err) => {
        console.log('error in homepageSliderImages: ' + err, err);
      });
    },

    showImage(deepLink) {
      try {
        if (!deepLink) {
          return;
        }
        // http://localhost:8080/#/Speise/mxh7bewfi2lm07ccds => /#/Speise/mxh7bewfi2lm07ccds
        let path = '/' + document.location.search + '#' + deepLink.split('#')[1];
        // alert('path = ' + path);
        window.location.href = path;
        util.jumpToTop(true, true);
        // ebus.$emit("goto", JSON.parse(deepLink));
      } catch (e) {

      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/styles/base.scss';


.homepageSlider.isKiosk {
  ::v-deep .VueCarousel-wrapper {
    border-radius: 0 0 25px 25px;

    .VueCarousel-slide {
      .v-image {
        border-radius: 0 0 25px 25px;
        //border-radius: 0 0 25px 25px;
      }
    }
  }
}

.homepageSlider:not(.isKiosk) {
  &.isMobile {
    ::v-deep .VueCarousel-wrapper:not(.isKiosk) {
      border-radius: 25px;

      .VueCarousel-slide {
        .v-image {
          border-radius: 25px;
          //border-radius: 0 0 25px 25px;
        }
      }
    }
  }
}

.homepageSlider {
  width: 100%;
  //height: 500px;
  //max-height: 500px;
  &.isMobile {
    margin-top: 0;
    margin-bottom: 35px;
  }

  &.isMd {
    margin-top: $headHeight;
    //height: 700px;
    max-height: 700px;
    //background-color: white;
  }
}

//@media (min-width: 768px) {
//  homepageSlider  ::v-deep .v-carousel__item {
//    border-radius: 0px;
//  }
//}

///* Media query for desktop */
//@media (min-width: 768px) {
//  .homepageSlider {
//    height: 700px;
//    max-height: 700px;
//    margin-top: $headHeight;
//  }
//  //.v-image__image {
//  //  height: 700px;
//  //  object-fit: cover;
//  //  background-size: cover;
//  //  background-repeat: no-repeat;
//  //  background-position: center;
//  //}
//}

.slider-item {
  object-fit: cover;
  // height: 280px;
  // max-height: 280px;
}

.v-window-item {
  padding: 0 0 20px 0;
}

.v-window__prev {
  opacity: 0;
}

.v-window__next {
  opacity: 0;
}

//.cssClass {
//  .v-btn {
//    width: 10px;
//    height: 10px;
//    margin-top: 30px;
//    color: #CBCACB !important;
//    background-color: #CBCACB !important;
//  }
//
//  .v-btn--active {
//    color: #771C0F !important;
//    background-color: #771C0F !important;
//  }
//}
::v-deep .VueCarousel {
  .VueCarousel-navigation-next, .VueCarousel-navigation-prev {
    width: 36px;
    height: 36px;
    border-radius: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
    line-height: 36px;
    font-size: 30px;
    color: #fff;
    background-color: rgba(0, 0, 0, 0.3);
    outline: none;

    &:before {
      font: normal normal normal 24px/1 Material Design Icons;
      font-size: inherit;
      text-rendering: auto;
      line-height: inherit;
    }
  }

  .VueCarousel-navigation-next {
    right: 50px;

    &:before {
      content: "\F0142";
    }
  }

  .VueCarousel-navigation-prev {
    left: 50px;

    &:before {
      content: "\F0141";
    }
  }
}
</style>
